module.exports = __webpack_public_path__ + "static/media/gm.6b410790.svg";